import { render, staticRenderFns } from "./CosocView.vue?vue&type=template&id=1f6e2080&"
import script from "./CosocView.vue?vue&type=script&lang=ts&"
export * from "./CosocView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports